export default "__VITE_ASSET__f6fd688b__"